import { isSmallStyle } from './functions';
import style from './styles/App.module.scss';
import { useSize } from './hooks/useSize';
import type { ReactElement, SVGAttributes } from 'react';

export default function PlayingTracker({ largeArcFlag, x, y }: SVGAttributes<SVGElement> & { largeArcFlag: 0|1 }): ReactElement {
    const sizeStyle = useSize();
    return (<svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${ style.progressCircle } ${ isSmallStyle(sizeStyle) ? sizeStyle.progressCircle : '' }`}
    >
        <circle
            className={style.progressCircleBackground}
            cx="15"
            cy="15"
            r="13"
            strokeWidth="2"
        />
        <path
            d={`M15 2A13 13 0 ${ largeArcFlag + ' 1 ' + x } ${ y }`}
            strokeWidth="3"
            stroke={'black'}
        />
    </svg>);
}